import { cn } from '@/lib/utils'

interface IncompleteBadgeProps {
  className?: string
}

/**
 * Small amber badge showing "Incomplete" status
 */
export function IncompleteBadge({ className }: IncompleteBadgeProps) {
  return (
    <span
      className={cn(
        'bg-[#f59e0b] text-white rounded-[48px] px-4 py-1.5 text-xs font-semibold',
        className
      )}
    >
      Incomplete
    </span>
  )
}
